/**
 * Enum for differentiating the types of links based on their purpose and protocol.
 */
export var ComponentType;
(function (ComponentType) {
    ComponentType["Email"] = "IsEmail";
    ComponentType["External"] = "IsExternal";
    ComponentType["Internal"] = "IsInternal";
    ComponentType["Telephone"] = "IsTelephone";
    ComponentType["Button"] = "IsButton";
    ComponentType["Fake"] = "IsFake";
    ComponentType["Input"] = "IsInput";
    ComponentType["Link"] = "Link"; // Represents a button used as a link for navigation.
})(ComponentType || (ComponentType = {}));
/**
 * Enum for defining type of links based on their navigational context or hierarchical role.
 */
export var NavType;
(function (NavType) {
    NavType["None"] = "";
    NavType["Nested"] = "nested";
    NavType["Primary"] = "primary"; // Links that are part of the primary navigation flow.
})(NavType || (NavType = {}));
/**
 * Enum for setting the number of columns in which links might be displayed, particularly in grid or multi-column layouts.
 */
export var LinkColumns;
(function (LinkColumns) {
    LinkColumns["One"] = "1";
    LinkColumns["Two"] = "2";
    LinkColumns["Three"] = "3"; // Three columns layout.
})(LinkColumns || (LinkColumns = {}));
/**
 * Enum for categorizing links based on their level in a hierarchical navigation structure.
 */
export var LinkLevel;
(function (LinkLevel) {
    LinkLevel["Zero"] = "0";
    LinkLevel["One"] = "1";
    LinkLevel["Two"] = "2";
    LinkLevel["Three"] = "3"; // Third level of hierarchy beneath the top.
})(LinkLevel || (LinkLevel = {}));
//# sourceMappingURL=LinkTypes.js.map